import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "view-result-card-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-6 open-sans-font current-date d-flex justify-content-end align-items-center" }
const _hoisted_7 = { class: "col-12 user-name open-sans-font" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.logoPath,
            class: "logo-theme"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_ctx.currentDate), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("b", null, _toDisplayString(_ctx.userName), 1)
        ])
      ])
    ])
  ]))
}